export const INSERT_CONDITIONAL_OFFER_MUTATION = `
  mutation InsertConditionalOffer($input: ConditionalOfferInsertInput!) {
    insertConditionalOffer(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;
